<template>
    <v-row>           
        <v-col>
            <v-card
                class="pa-0 mx-auto"
                width="350"                
                elevation="2"
                outlined                
            >
                <v-toolbar
                    color="primary"
                    dark
                >
                    <v-toolbar-title>Application Settings</v-toolbar-title>
                </v-toolbar>
                <v-list>                    
                    <v-list-item-group
                        color="primary"
                    >
                        <v-list-item
                            v-for="(item, i) in items"
                            :key="i"
                            @click="display(item)"
                        >
                            <v-list-item-avatar>
                                <v-icon
                                    color="primary"
                                >
                                    {{ item.icon }}
                                </v-icon>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.text }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </v-col>

        <SetTerm
            v-if="dialog.setTerm"
            v-bind:dialog-open="dialog.setTerm"
            v-on:dialog-close="dialogClose"
        ></SetTerm>

        <PostReports
            v-if="dialog.postReports"
            v-bind:dialog-open="dialog.postReports"
            v-on:dialog-close="dialogClose"
            v-on:snackbar-open="displaySnackbar"
        ></PostReports>

        <AddEditSubjects
            v-if="dialog.addEditSubjects"
            v-bind:dialog-open="dialog.addEditSubjects"
            v-on:dialog-close="dialogClose"
        ></AddEditSubjects>
        
        <PromoteStudents
            v-if="dialog.promoteStudents"
            v-bind:dialog-open="dialog.promoteStudents"
            v-on:dialog-close="dialogClose"
            v-on:snackbar-open="snackbarOpen"
        ></PromoteStudents>

        <UserPermissions
            v-if="dialog.userPermissions"
            v-bind:dialog-open="dialog.userPermissions"
            v-on:dialog-close="dialogClose"
        ></UserPermissions>

        <UserListing
            v-if="dialog.userListing"
            v-bind:dialog-open="dialog.userListing"
            v-on:dialog-close="dialogClose"
        ></UserListing>

        <CocurricularClubs
            v-if="dialog.cocurricularClubs"
            v-bind:dialog-open="dialog.cocurricularClubs"
            v-on:dialog-close="dialogClose"
        ></CocurricularClubs>

        <v-snackbar
            v-model="snackbar.display"
            :color="snackbar.color"
        >
            {{ snackbar.text }}

            <template v-slot:action="{ attrs }">
                <v-btn
                    text
                    v-bind="attrs"
                    @click="snackbar.display = false"
                >Close</v-btn>
            </template>
        </v-snackbar>
    </v-row>        
</template>

<script>
import SetTerm from './SettingsSetTerm';
import AddEditSubjects from './SettingsAddEditSubjects';
import PromoteStudents from './SettingsPromoteStudents.vue';
import UserPermissions from './SettingsUserPermissions.vue';
import UserListing from './SettingsUserListing.vue';
import PostReports from './SettingsPostReports.vue';
import CocurricularClubs from './SettingsCocurricularClubs.vue';
import { mapGetters } from 'vuex';
export default {
    components: {
        SetTerm,
        AddEditSubjects,
        PromoteStudents,
        UserPermissions,
        UserListing,
        PostReports,
        CocurricularClubs,
    },

    created: function() {
        this.initialize();
    },

    data: () => ({        
        itemsAll: [
            {
                text: 'Set Current Term', 
                icon: 'mdi-calendar-cursor',
                value: 'setTerm',
            },
            {
                text: 'Post Reports', 
                icon: 'mdi-upload-lock',
                value: 'postReports'
            },
            {
                text: 'Add / Edit Subjects', 
                icon: 'mdi-bookshelf',
                value: 'addEditSubjects',
            },
            {
                text: 'Add / Edit Co-Curricular Clubs', 
                icon: 'mdi-basketball',
                value: 'cocurricularClubs',
            },
            // {
            //     text: 'Promote Students', 
            //     icon: 'mdi-account-arrow-up',
            //     value: 'promoteStudents'
            // },
            {
                text: 'User Permissions', 
                icon: 'mdi-lock-check',
                value: 'userPermissions'
            },
            {
                text: 'Employee User Listing', 
                icon: 'mdi-file-outline',
                value: 'userListing'
            },
        ],
        items: [],
        dialog:{
            editViewTermRegistration: false,
            setTerm: false,
            postReports: false,
            addEditSubjects: false,
            promoteStudents: false,
            userPermissions: false,
            userListing: false,
            cocurricularClubs: false,
        },
        snackbar: {
            display: false,
            text: '',
            color: '',
        }
    }),

    computed: {
        ...mapGetters({
            admin: 'auth/getAdmin',
        })
    },

    methods: {

        initialize () {
            this.items = this.itemsAll.filter(item => {
                if(!this.admin && item.value === 'userPermissions'){
                    // return false;
                } 
                return true;
            })
        },
        
        display (item) {
            Object.keys(this.dialog).forEach(k => {
                this.dialog[k] = false;
                if(k === item.value){
                    this.dialog[k] = true;
                }
            })
        },

        snackbarOpen ({ color, text }) {
            this.snackbar.display = true;
            this.snackbar.color = color;
            this.snackbar.text = text;
        },

        dialogClose () {
            Object.keys(this.dialog).forEach(k => {
                this.dialog[k] = false;
            })
        },

        displaySnackbar (snackbar) {
            this.snackbar.display = true;
            this.snackbar.message = snackbar.message;
            this.snackbar.color = snackbar.color;
        }

    }
}
</script>